import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';

// Finance checklist screen
import { FinanceChecklistScreen } from '../../screens/checklists/FinanceChecklistScreen';
import { AccountantInfoDataScreen } from '../../screens/tasks/finance/accountant/AccountantInfoDataScreen';
import { AccountantInfoInputScreen } from '../../screens/tasks/finance/accountant/AccountantInfoInputScreen';
import { AccountantInfoIntroScreen } from '../../screens/tasks/finance/accountant/AccountantInfoIntroScreen';
import { AccountantInfoLockedScreen } from '../../screens/tasks/finance/accountant/AccountantInfoLockedScreen';
import { AccountantInfoLockUnlockScreen } from '../../screens/tasks/finance/accountant/AccountantInfoLockUnlockScreen';
import { AccountantInfoUnlockedScreen } from '../../screens/tasks/finance/accountant/AccountantInfoUnlockedScreen';

// Attorney screens
import { AttorneyInfoDataScreen } from '../../screens/tasks/finance/attorney/AttorneyInfoDataScreen';
import { AttorneyInfoInputScreen } from '../../screens/tasks/finance/attorney/AttorneyInfoInputScreen';
import { AttorneyInfoIntroScreen } from '../../screens/tasks/finance/attorney/AttorneyInfoIntroScreen';
import { AttorneyInfoLockedScreen } from '../../screens/tasks/finance/attorney/AttorneyInfoLockedScreen';
import { AttorneyInfoLockUnlockScreen } from '../../screens/tasks/finance/attorney/AttorneyInfoLockUnlockScreen';
import { AttorneyInfoUnlockedScreen } from '../../screens/tasks/finance/attorney/AttorneyInfoUnlockedScreen';

// Investment Advisor screens
import { InvestmentAdvisorInfoDataScreen } from '../../screens/tasks/finance/investment-advisor/InvestmentAdvisorInfoDataScreen';
import { InvestmentAdvisorInfoInputScreen } from '../../screens/tasks/finance/investment-advisor/InvestmentAdvisorInfoInputScreen';
import { InvestmentAdvisorInfoIntroScreen } from '../../screens/tasks/finance/investment-advisor/InvestmentAdvisorInfoIntroScreen';
import { InvestmentAdvisorInfoLockedScreen } from '../../screens/tasks/finance/investment-advisor/InvestmentAdvisorInfoLockedScreen';
import { InvestmentAdvisorInfoLockUnlockScreen } from '../../screens/tasks/finance/investment-advisor/InvestmentAdvisorInfoLockUnlockScreen';
import { InvestmentAdvisorInfoUnlockedScreen } from '../../screens/tasks/finance/investment-advisor/InvestmentAdvisorInfoUnlockedScreen';

// Insurance Agent screens
import { InsuranceAgentInfoDataScreen } from '../../screens/tasks/finance/insurance-agent/InsuranceAgentInfoDataScreen';
import { InsuranceAgentInfoInputScreen } from '../../screens/tasks/finance/insurance-agent/InsuranceAgentInfoInputScreen';
import { InsuranceAgentInfoIntroScreen } from '../../screens/tasks/finance/insurance-agent/InsuranceAgentInfoIntroScreen';
import { InsuranceAgentInfoLockedScreen } from '../../screens/tasks/finance/insurance-agent/InsuranceAgentInfoLockedScreen';
import { InsuranceAgentInfoLockUnlockScreen } from '../../screens/tasks/finance/insurance-agent/InsuranceAgentInfoLockUnlockScreen';
import { InsuranceAgentInfoUnlockedScreen } from '../../screens/tasks/finance/insurance-agent/InsuranceAgentInfoUnlockedScreen';

// Tax Advisor screens
import { TaxAdvisorInfoDataScreen } from '../../screens/tasks/finance/taxAdvisor/TaxAdvisorInfoDataScreen';
import { TaxAdvisorInfoInputScreen } from '../../screens/tasks/finance/taxAdvisor/TaxAdvisorInfoInputScreen';
import { TaxAdvisorInfoIntroScreen } from '../../screens/tasks/finance/taxAdvisor/TaxAdvisorInfoIntroScreen';
import { TaxAdvisorInfoLockedScreen } from '../../screens/tasks/finance/taxAdvisor/TaxAdvisorInfoLockedScreen';
import { TaxAdvisorInfoLockUnlockScreen } from '../../screens/tasks/finance/taxAdvisor/TaxAdvisorInfoLockUnlockScreen';
import { TaxAdvisorInfoUnlockedScreen } from '../../screens/tasks/finance/taxAdvisor/TaxAdvisorInfoUnlockedScreen';

// Credit Card screens
import { CreditCardInfoDataScreen } from '../../screens/tasks/finance/creditCards/CreditCardInfoDataScreen';
import { CreditCardInfoInputScreen } from '../../screens/tasks/finance/creditCards/CreditCardInfoInputScreen';
import { CreditCardInfoIntroScreen } from '../../screens/tasks/finance/creditCards/CreditCardInfoIntroScreen';
import { CreditCardInfoLockedScreen } from '../../screens/tasks/finance/creditCards/CreditCardInfoLockedScreen';
import { CreditCardInfoLockUnlockScreen } from '../../screens/tasks/finance/creditCards/CreditCardInfoLockUnlockScreen';
import { CreditCardInfoUnlockedScreen } from '../../screens/tasks/finance/creditCards/CreditCardInfoUnlockedScreen';

// Banking screens
import { BankingInfoDataScreen } from '../../screens/tasks/finance/banking/BankingInfoDataScreen';
import { BankingInfoInputScreen } from '../../screens/tasks/finance/banking/BankingInfoInputScreen';
import { BankingInfoIntroScreen } from '../../screens/tasks/finance/banking/BankingInfoIntroScreen';
import { BankingInfoLockedScreen } from '../../screens/tasks/finance/banking/BankingInfoLockedScreen';
import { BankingInfoLockUnlockScreen } from '../../screens/tasks/finance/banking/BankingInfoLockUnlockScreen';
import { BankingInfoUnlockedScreen } from '../../screens/tasks/finance/banking/BankingInfoUnlockedScreen';

// Investments screens
import { InvestmentsInfoDataScreen } from '../../screens/tasks/finance/investments/InvestmentsInfoDataScreen';
import { InvestmentsInfoInputScreen } from '../../screens/tasks/finance/investments/InvestmentsInfoInputScreen';
import { InvestmentsInfoIntroScreen } from '../../screens/tasks/finance/investments/InvestmentsInfoIntroScreen';
import { InvestmentsInfoLockedScreen } from '../../screens/tasks/finance/investments/InvestmentsInfoLockedScreen';
import { InvestmentsInfoLockUnlockScreen } from '../../screens/tasks/finance/investments/InvestmentsInfoLockUnlockScreen';
import { InvestmentsInfoUnlockedScreen } from '../../screens/tasks/finance/investments/InvestmentsInfoUnlockedScreen';

// Loan screens
import { LoanInfoDataScreen } from '../../screens/tasks/finance/loans/LoanInfoDataScreen';
import { LoanInfoInputScreen } from '../../screens/tasks/finance/loans/LoanInfoInputScreen';
import { LoanInfoIntroScreen } from '../../screens/tasks/finance/loans/LoanInfoIntroScreen';
import { LoanInfoLockedScreen } from '../../screens/tasks/finance/loans/LoanInfoLockedScreen';
import { LoanInfoLockUnlockScreen } from '../../screens/tasks/finance/loans/LoanInfoLockUnlockScreen';
import { LoanInfoUnlockedScreen } from '../../screens/tasks/finance/loans/LoanInfoUnlockedScreen';

// Crypto screens
import { CryptoInfoDataScreen } from '../../screens/tasks/finance/crypto/CryptoInfoDataScreen';
import { CryptoInfoInputScreen } from '../../screens/tasks/finance/crypto/CryptoInfoInputScreen';
import { CryptoInfoIntroScreen } from '../../screens/tasks/finance/crypto/CryptoInfoIntroScreen';
import { CryptoInfoLockedScreen } from '../../screens/tasks/finance/crypto/CryptoInfoLockedScreen';
import { CryptoInfoLockUnlockScreen } from '../../screens/tasks/finance/crypto/CryptoInfoLockUnlockScreen';
import { CryptoInfoUnlockedScreen } from '../../screens/tasks/finance/crypto/CryptoInfoUnlockedScreen';

const Stack = createNativeStackNavigator();

const FinanceStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="FinanceChecklist" component={FinanceChecklistScreen} />
      <Stack.Screen name="AccountantInfoIntro" component={AccountantInfoIntroScreen} />
      <Stack.Screen name="AccountantInfoInput" component={AccountantInfoInputScreen} />
      <Stack.Screen name="AccountantInfoLockUnlock" component={AccountantInfoLockUnlockScreen} />
      <Stack.Screen name="AccountantInfoUnlocked" component={AccountantInfoUnlockedScreen} />
      <Stack.Screen name="AccountantInfoLocked" component={AccountantInfoLockedScreen} />
      <Stack.Screen name="AccountantInfoData" component={AccountantInfoDataScreen} />
      
      <Stack.Screen name="AttorneyInfoIntro" component={AttorneyInfoIntroScreen} />
      <Stack.Screen name="AttorneyInfoInput" component={AttorneyInfoInputScreen} />
      <Stack.Screen name="AttorneyInfoLockUnlock" component={AttorneyInfoLockUnlockScreen} />
      <Stack.Screen name="AttorneyInfoUnlocked" component={AttorneyInfoUnlockedScreen} />
      <Stack.Screen name="AttorneyInfoLocked" component={AttorneyInfoLockedScreen} />
      <Stack.Screen name="AttorneyInfoData" component={AttorneyInfoDataScreen} />
      
      <Stack.Screen name="InvestmentAdvisorInfoIntro" component={InvestmentAdvisorInfoIntroScreen} />
      <Stack.Screen name="InvestmentAdvisorInfoInput" component={InvestmentAdvisorInfoInputScreen} />
      <Stack.Screen name="InvestmentAdvisorInfoLockUnlock" component={InvestmentAdvisorInfoLockUnlockScreen} />
      <Stack.Screen name="InvestmentAdvisorInfoUnlocked" component={InvestmentAdvisorInfoUnlockedScreen} />
      <Stack.Screen name="InvestmentAdvisorInfoLocked" component={InvestmentAdvisorInfoLockedScreen} />
      <Stack.Screen name="InvestmentAdvisorInfoData" component={InvestmentAdvisorInfoDataScreen} />
      
      <Stack.Screen name="InsuranceAgentInfoIntro" component={InsuranceAgentInfoIntroScreen} />
      <Stack.Screen name="InsuranceAgentInfoInput" component={InsuranceAgentInfoInputScreen} />
      <Stack.Screen name="InsuranceAgentInfoLockUnlock" component={InsuranceAgentInfoLockUnlockScreen} />
      <Stack.Screen name="InsuranceAgentInfoUnlocked" component={InsuranceAgentInfoUnlockedScreen} />
      <Stack.Screen name="InsuranceAgentInfoLocked" component={InsuranceAgentInfoLockedScreen} />
      <Stack.Screen name="InsuranceAgentInfoData" component={InsuranceAgentInfoDataScreen} />
      
      <Stack.Screen name="BankingInfoIntro" component={BankingInfoIntroScreen} />
      <Stack.Screen name="BankingInfoInput" component={BankingInfoInputScreen} />
      <Stack.Screen name="BankingInfoLockUnlock" component={BankingInfoLockUnlockScreen} />
      <Stack.Screen name="BankingInfoUnlocked" component={BankingInfoUnlockedScreen} />
      <Stack.Screen name="BankingInfoLocked" component={BankingInfoLockedScreen} />
      <Stack.Screen name="BankingInfoData" component={BankingInfoDataScreen} />
      
      <Stack.Screen name="TaxAdvisorInfoIntro" component={TaxAdvisorInfoIntroScreen} />
      <Stack.Screen name="TaxAdvisorInfoInput" component={TaxAdvisorInfoInputScreen} />
      <Stack.Screen name="TaxAdvisorInfoLockUnlock" component={TaxAdvisorInfoLockUnlockScreen} />
      <Stack.Screen name="TaxAdvisorInfoUnlocked" component={TaxAdvisorInfoUnlockedScreen} />
      <Stack.Screen name="TaxAdvisorInfoLocked" component={TaxAdvisorInfoLockedScreen} />
      <Stack.Screen name="TaxAdvisorInfoData" component={TaxAdvisorInfoDataScreen} />
      
      <Stack.Screen name="CreditCardInfoIntro" component={CreditCardInfoIntroScreen} />
      <Stack.Screen name="CreditCardInfoInput" component={CreditCardInfoInputScreen} />
      <Stack.Screen name="CreditCardInfoLockUnlock" component={CreditCardInfoLockUnlockScreen} />
      <Stack.Screen name="CreditCardInfoUnlocked" component={CreditCardInfoUnlockedScreen} />
      <Stack.Screen name="CreditCardInfoLocked" component={CreditCardInfoLockedScreen} />
      <Stack.Screen name="CreditCardInfoData" component={CreditCardInfoDataScreen} />
      
      <Stack.Screen name="InvestmentsInfoIntro" component={InvestmentsInfoIntroScreen} />
      <Stack.Screen name="InvestmentsInfoInput" component={InvestmentsInfoInputScreen} />
      <Stack.Screen name="InvestmentsInfoLockUnlock" component={InvestmentsInfoLockUnlockScreen} />
      <Stack.Screen name="InvestmentsInfoUnlocked" component={InvestmentsInfoUnlockedScreen} />
      <Stack.Screen name="InvestmentsInfoLocked" component={InvestmentsInfoLockedScreen} />
      <Stack.Screen name="InvestmentsInfoData" component={InvestmentsInfoDataScreen} />
      
      <Stack.Screen name="LoanInfoIntro" component={LoanInfoIntroScreen} />
      <Stack.Screen name="LoanInfoInput" component={LoanInfoInputScreen} />
      <Stack.Screen name="LoanInfoLockUnlock" component={LoanInfoLockUnlockScreen} />
      <Stack.Screen name="LoanInfoUnlocked" component={LoanInfoUnlockedScreen} />
      <Stack.Screen name="LoanInfoLocked" component={LoanInfoLockedScreen} />
      <Stack.Screen name="LoanInfoData" component={LoanInfoDataScreen} />
      
      <Stack.Screen name="CryptoInfoIntro" component={CryptoInfoIntroScreen} />
      <Stack.Screen name="CryptoInfoInput" component={CryptoInfoInputScreen} />
      <Stack.Screen name="CryptoInfoLockUnlock" component={CryptoInfoLockUnlockScreen} />
      <Stack.Screen name="CryptoInfoUnlocked" component={CryptoInfoUnlockedScreen} />
      <Stack.Screen name="CryptoInfoLocked" component={CryptoInfoLockedScreen} />
      <Stack.Screen name="CryptoInfoData" component={CryptoInfoDataScreen} />
    </Stack.Navigator>
  );
};

export default FinanceStackNavigator;